var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "分配负责人",
        visible: _vm.dialogVisible,
        width: "560px",
        "append-to-body": "",
        "before-close": _vm.handleDialogClose,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.detailLoading,
              expression: "detailLoading",
            },
          ],
          ref: "assignForm",
          attrs: {
            model: _vm.assignForm,
            rules: _vm.assignRules,
            "label-width": "100px",
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "客户名称", prop: "customer_name" } },
            [
              _c("el-input", {
                attrs: { disabled: "" },
                model: {
                  value: _vm.assignForm.customer_name,
                  callback: function ($$v) {
                    _vm.$set(_vm.assignForm, "customer_name", $$v)
                  },
                  expression: "assignForm.customer_name",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "项目名称", prop: "project_name" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入项目名称", clearable: "" },
                model: {
                  value: _vm.assignForm.project_name,
                  callback: function ($$v) {
                    _vm.$set(_vm.assignForm, "project_name", $$v)
                  },
                  expression: "assignForm.project_name",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "负责人", prop: "person_charge_id" } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    placeholder: "请选择",
                    filterable: "",
                    clearable: "",
                  },
                  model: {
                    value: _vm.assignForm.person_charge_id,
                    callback: function ($$v) {
                      _vm.$set(_vm.assignForm, "person_charge_id", $$v)
                    },
                    expression: "assignForm.person_charge_id",
                  },
                },
                _vm._l(_vm.leaderOptions, function (item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.name, value: item.id },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "备注" } },
            [
              _c("el-input", {
                attrs: {
                  type: "textarea",
                  placeholder: "请输入...",
                  maxlength: "300",
                  "show-word-limit": "",
                  rows: 4,
                },
                model: {
                  value: _vm.assignForm.remarks,
                  callback: function ($$v) {
                    _vm.$set(_vm.assignForm, "remarks", $$v)
                  },
                  expression: "assignForm.remarks",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  _vm.dialogVisible = false
                },
              },
            },
            [_vm._v("取 消")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", loading: _vm.submitLoading },
              on: { click: _vm.submitAssign },
            },
            [_vm._v("确 定")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }